//=========================================================//
//                                                         //
//                          IMPORT                         //
//                                                         //
//=========================================================//
//------------------------ VUE STUFF ----------------------//
import Vue from 'vue';
import Router from 'vue-router';


//------------------------- PROFILE -----------------------//
import ForgetPW from '@/components/Profile/ForgetPW';
import Login from '@/components/Profile/Login';
import UpdateEmail from '@/components/Profile/UpdateEmail';
import UpdatePassword from '@/components/Profile/UpdatePassword';
import ProfileManager from '@/components/ProfileManager';
import Business from '@/components/Business';

//------------------------- ORDERS -----------------------//
import Orders from '@/components/Orders_v2';
import History from '@/components/History';

//------------------------- MANAGER -----------------------//
import Manager from '@/components/Manager';
// import Products from '@/components/Manager/Products';
import ProductsAlone from '@/components/Manager/ProductsAlone';
import Categories from '@/components/Manager/Categories';
import SpecialSchedule from '@/components/Manager/SpecialSchedule';
import StoreSetting from '@/components/Manager/StoreSetting';
import DeliveryFeeCalculator from '@/components/Manager/DeliveryFeeCalculator';

//------------------------- OTHERS -----------------------//
import WhatIsNew from '@/components/WhatIsNew';

Vue.use(Router)

export default new Router({
	mode: "history",
	routes: [
	{
		path: '/:businessID',
		name: 'Business',
		component: Business,
		children:[
		{
			path: 'orders',
			name: 'Orders',
			component: Orders,
		},
		{
			path: 'history',
			name: 'History',
			component: History,
		},
		{
			path: 'products',
			name: 'Products',
			component: ProductsAlone,
		},

		{
			path: 'what-is-new',
			name: 'What is New?',
			component: WhatIsNew,
		},
		{
			path: 'manager',
			name: 'Manager',
			component: Manager,
			children:[
			{
				path: 'schedule',
				name: 'Schedule',
				component: SpecialSchedule,
			},
			{
				path: 'products',
				name: 'Products',
				component: ProductsAlone,
			},
			{
				path: 'categories',
				name: 'Categories',
				component: Categories,
			},
			{
				path: 'setting',
				name: 'Store Setting',
				component: StoreSetting,
			},
			{
				path: 'delivery-fee-calculator',
				name: 'Delivery Fee Calculator',
				component: DeliveryFeeCalculator,
			},
			]
		},
		//---------------------- PROFILE ------------------------//
		{
			path: 'login',
			name: 'Login',
			component: Login,
		},
		{
			path: 'forgot-password',
			name: 'Forgot Password',
			component: ForgetPW,
		},
		{
			path: 'profile-manager',
			name: 'Profile Manager',
			component: ProfileManager,
			children:[
			{
				path: 'update-password',
				name: 'Update Password',
				component: UpdatePassword,
			},
			{
				path: 'update-email',
				name: 'Update Email',
				component: UpdateEmail,
			}
			]
		},
		]
	}


	]
})



// WEBPACK FOOTER //
// ./src/router/index.js